import { useQuery } from '@tanstack/react-query'

import { fetchOUs } from 'api/fetchers/marketing-capabilities/practitioners/OUs/fetchOUs'
import { TAB_SECTION } from 'pages/exploreLearnings/constants/tabSection.constants'

export const usePractitionersOus = () => {
  return useQuery({
    queryKey: ['practitioners-ous'],
    queryFn: ({ signal }: any) => fetchOUs(TAB_SECTION.resources)(signal),
    select: (data: any) => data.data,
    enabled: true,
  })
}
